import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {

  ListadoNombres
} from '../models/interfaz';
import {ApiUrlService} from './api-url.service';

export interface AlertMessage {
  type: 'success' | 'error' | 'info' | 'warning';
  summary: string;
  detail: string;
}

@Injectable({
  providedIn: 'root'
})
export class ServiceService {

  /*
    private readonly CACHE_TTL = 2 * 60 * 1000;
  */

  constructor(private apiUrl: ApiUrlService, private http: HttpClient) {
  }


  // ALERTAS
  private alertSubject = new BehaviorSubject<AlertMessage | null>(null);
  alert$ = this.alertSubject.asObservable();

  showAlert(message: AlertMessage) {
    this.alertSubject.next(message);
  }

  clearAlert() {
    this.alertSubject.next(null);
  }


}

